// ─────────────────────────────────────────────────────────────
// OLD SCROLL-BASED IMPLEMENTATION (commented out)
// ─────────────────────────────────────────────────────────────
// import { useState } from "react";
// import ScrollStack, { ScrollStackItem } from "./ScrollMapComponent/ScrollStack";
// import InteractiveMap from "./ScrollMapComponent/InteractiveMap";
// import { Box, Typography } from "@mui/material";
// import GlobalReachVideo from "../assets/videos/dureWorldReach.mp4";
//
// const GlobalReach = () => {
//   const [mapBlurred, setMapBlurred] = useState(false);
//   const [currentCountry, setCurrentCountry] = useState(null);
//   const countryData = [ ... ];
//   return (
//     <>
//       <Box>
//         <Box sx={{ position: "relative" }} className="globalReachSection">
//           <Box className={mapBlurred ? "map-blurred" : ""} sx={{ position: "sticky", top: 0, width: "100%", height: "100vh", zIndex: 0, overflow: "visible" }}>
//             ...
//             <InteractiveMap currentCountry={currentCountry} />
//           </Box>
//           <ScrollStack className="country-scroll" useWindowScroll onItemActive={(index) => { setMapBlurred(index !== null); setCurrentCountry(index !== null ? countryData[index].countryCode : null); }}>
//             {countryData.map((data, index) => (
//               <ScrollStackItem key={index}>
//                 <h3 className="scroll-cardcountryName">{data.heading}</h3>
//                 <p className="scroll-cardcountryBody">{data.body}</p>
//               </ScrollStackItem>
//             ))}
//           </ScrollStack>
//         </Box>
//         <Box className="mobileGlobalReachSection">
//           <video src={GlobalReachVideo} autoPlay loop muted playsInline preload="auto" className="rounded-2xl shadow-lg w-100" />
//         </Box>
//       </Box>
//     </>
//   );
// };
// export default GlobalReach;
// ─────────────────────────────────────────────────────────────

import { useState } from "react";
import InteractiveMap from "./ScrollMapComponent/InteractiveMap";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import GlobalReachVideo from "../assets/videos/dureWorldReach.mp4";

const GlobalReach = () => {
  // -1 = world view, 0–3 = active country
  const [activeIndex, setActiveIndex] = useState(-1);

  const countryData = [
    {
      heading: "NIGERIA",
      body: "Nigeria, under the leadership of the Ministry of Health, is driving digital transformation through multi-program National Situation Rooms that unify data across HIV, TB, malaria, immunization, and outbreak response. Alongside this, a community-led monitoring system empowers citizens to provide bottom-up insights, creating a more integrated, resilient, and participatory health system that sets a benchmark for the region.",
      countryCode: "NGA",
    },
    {
      heading: "CENTRAL AFRICAN REPUBLIC (CAR)",
      body: "Despite its fragility, the Central African Republic is driving one of the region's most comprehensive digital transformation efforts, guided by the vision of the Minister of Health and other key ministries. By integrating digital health solutions with enabling infrastructure and capacity building, the country is setting a benchmark for resilience and innovation that can inspire neighboring nations.",
      countryCode: "CAF",
    },
    {
      heading: "SWITZERLAND",
      body: "Dure Technologies's Geneva hub serves as a global center for innovation and partnerships, hosting the Swiss Obesity Registry, the Global OneImpact platform for HIV and TB, and the Climate and Health Knowledge Hub. It anchors collaborations with UN agencies, events and the ACESS Accelerator, advancing digital transformation and AI for global health.",
      countryCode: "CHE",
    },
    {
      heading: "United Arab Emirates (UAE)",
      body: "As part of Dure Technologies, Vitafi - UAE has been created to explore, develop, and deploy AI solutions tailored for the Middle East. Our focus spans Healthcare, Insurance, ESG, Oil and Gas and Climate Health, but our vision goes beyond — we aim to redefine enterprise decision-making across industries.",
      countryCode: "ARE",
    },
  ];

  const isWorldView = activeIndex === -1;
  const currentCountry = isWorldView
    ? null
    : countryData[activeIndex].countryCode;
  const mapBlurred = !isWorldView;

  const handleNext = () => {
    setActiveIndex((prev) => (prev === countryData.length - 1 ? -1 : prev + 1));
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === -1 ? countryData.length - 1 : prev - 1));
  };

  return (
    <>
      <Box>
        <Box sx={{ position: "relative" }} className="globalReachSection">
          <Box
            className={mapBlurred ? "map-blurred" : ""}
            sx={{
              position: "sticky",
              top: 0,
              width: "100%",
              height: "100vh",
              zIndex: 0,
              overflow: "visible",
            }}
          >
            <Typography
              variant="h4"
              fontWeight="bold"
              letterSpacing={2}
              gutterBottom
              className="mainHeading"
            >
              GLOBAL REACH
            </Typography>

            {/* Tagline — fades out when a country is active */}
            <Typography
              variant="h6"
              className={`mapTagLine ${mapBlurred ? "mapTagLine-hidden" : ""}`}
              sx={{
                textAlign: { xs: "center", md: "left" },
                transition: "opacity 750ms ease-in-out",
                opacity: mapBlurred ? 0 : 1,
              }}
            >
              Projects <br />
              across{" "}
              <Box component="span" sx={{ fontWeight: 700 }}>
                50+
              </Box>{" "}
              <br />
              Countries
            </Typography>

            {/* Interactive Map */}
            <InteractiveMap currentCountry={currentCountry} />

            {/* ── Country card — LEFT side, same position as scroll cards ── */}
            {!isWorldView && (
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: { xs: 16, md: 48 },
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  // maxWidth: { xs: 260, sm: 320, md: 360 },
                }}
              >
                <div className="scroll-stack-card">
                  <h3 className="scroll-cardcountryName">
                    {countryData[activeIndex].heading}
                  </h3>
                  <p className="scroll-cardcountryBody">
                    {countryData[activeIndex].body}
                  </p>
                </div>
              </Box>
            )}

            {/* ── Prev / Next buttons — RIGHT side, always fixed, never shift ── */}
            <Box
              sx={{
                position: "absolute",
                bottom: { xs: 24, md: 40 },
                right: { xs: 16, md: 48 },
                display: "flex",
                flexDirection: "row", // ← horizontal
                gap: 1,
                zIndex: 10,
              }}
            >
              {/* Rotating glow ring wraps both buttons */}
              <div className="carousel-glow-ring">
                <Tooltip title="Previous" placement="top" arrow>
                  <IconButton
                    onClick={handlePrev}
                    size="small"
                    className="carousel-btn"
                    sx={{
                      "&:hover": { backgroundColor: "#b491d0", color: "#fff" },
                      transition: "background-color 0.2s ease",
                    }}
                  >
                    <ArrowBackIosNewIcon fontSize="small" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Next" placement="top" arrow>
                  <IconButton
                    onClick={handleNext}
                    size="small"
                    className="carousel-btn"
                    sx={{
                      "&:hover": { backgroundColor: "#b491d0", color: "#fff" },
                      transition: "background-color 0.2s ease",
                    }}
                  >
                    <ArrowForwardIosIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>
            </Box>

            {/* ── Dot indicators — bottom center ── */}
            <Box
              sx={{
                position: "absolute",
                bottom: { xs: 24, md: 40 },
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                gap: 1,
                zIndex: 10,
              }}
            >
              <Box
                onClick={() => setActiveIndex(-1)}
                className={`carousel-dot ${
                  isWorldView ? "carousel-dot--active" : ""
                }`}
              />
              {countryData.map((_, i) => (
                <Box
                  key={i}
                  onClick={() => setActiveIndex(i)}
                  className={`carousel-dot ${
                    activeIndex === i ? "carousel-dot--active" : ""
                  }`}
                />
              ))}
            </Box>
          </Box>
        </Box>

        <Box className="mobileGlobalReachSection">
          <video
            src={GlobalReachVideo}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="rounded-2xl shadow-lg w-100"
          />
        </Box>
      </Box>
    </>
  );
};

export default GlobalReach;
